import { harvestYearDetail } from "../../config/harvestYearDetail";
import { userDetail } from "../../config/userDetails";
import { globalApiHandler } from "../../services/services";
import { formatDate } from "../../utils/DateFormatter";
import DropdownOptions from "../../constants/DropdownOptions";

export const LOAD = {
  list: {
    success: "LOAD_GET_ALL_SUCCESS",
    error: "LOAD_GET_ALL_ERROR"
  },
  create: {
    success: "LOAD_CREATE_SUCCESS",
    error: "LOAD_CREATE_ERROR"
  },
  edit: {
    success: "LOAD_EDIT_SUCCESS",
    error: "LOAD_EDIT_ERROR"
  },
  update: {
    success: "LOAD_UPDATE_SUCCESS",
    error: "LOAD_UPDATE_ERROR"
  },
  delete: {
    success: "LOAD_DELETE_SUCCESS",
    error: "LOAD_DELETE_ERROR"
  }
};

export const loadIndicatorListAction = (
  id,
  harvestYear = harvestYearDetail().name,
  fieldGroupId
) => {
  return (dispatch, getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    /* in case of superAdmin no parentFarmId is associated therefore using selectedMainFarm
    from mainFarm Dropdown*/
    let url = `/ntrac/fieldgroup/farmId/loadnumberindicatorList/${
      userDetail().parentFarmId ? userDetail().parentFarmId : selectedMainFarm
    }?harvestYear=${harvestYear}&fieldGroupId=${fieldGroupId}`;
    globalApiHandler(url, "get", {})
      .then(response => {
        const data = response.data.data;
        data.map(item => {
          item.updatedAt = formatDate(item.updatedAt);
        });
        dispatch({ type: LOAD.list.success, data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const createLoadIndicatorAction = loadInfo => {
  return (dispatch, getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    let url =
      selectedMainFarm !== DropdownOptions.ALL_MAIN_FARM.id
        ? `/ntrac/fieldgroup/loadnumberindicator?farmId=${selectedMainFarm}`
        : `/ntrac/fieldgroup/loadnumberindicator`;
    globalApiHandler(url, "post", loadInfo)
      .then(response => {
        dispatch({ type: LOAD.create.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const editLoadIndicatorAction = data => {
  return dispatch => {
    dispatch({ type: LOAD.edit.success, data });
  };
};

export const updateLoadIndicatorAction = loadInfo => {
  let url = `/ntrac/fieldgroup/loadnumberindicator/${loadInfo.id}`;
  return (dispatch, getState) => {
    const selectedMainFarm = getState().FarmManagementReducer.MainFarmId;
    let url =
      selectedMainFarm !== DropdownOptions.ALL_MAIN_FARM.id
        ? `/ntrac/fieldgroup/loadnumberindicator/${loadInfo.id}?farmId=${selectedMainFarm}`
        : `/ntrac/fieldgroup/loadnumberindicator/${loadInfo.id}`;
    globalApiHandler(url, "put", loadInfo)
      .then(response => {
        dispatch({ type: LOAD.update.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const deleteLoadIndicatorAction = id => {
  let url = `/ntrac/fieldgroup/loadnumberindicator/${id}`;
  return dispatch => {
    globalApiHandler(url, "delete", {})
      .then(response => {
        const data = response.data.data;
        dispatch({ type: LOAD.delete.success, data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/loadnoindicator/action.js